// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1gUsP","title":"BackImages_title__1EFQD","images":"BackImages_images__3WzF7"};